import MiniHero from "../components/hero/MiniHero";
import StatisticsCounter from "../components/about/count";
import EngagementsSection from "../components/about/engagement";
import LawFirmHero from "../components/about/LawFirmHero";
import Intro from "../components/about/intro";
import RecentBlogArea from "../components/blogs/RecentBlogs";
import { blogs } from "./Home"; // adjust the path if needed

const About = () => {
    const stats = [

        {
            icon: "scale",
            number: 927,
            label: "Projets accompagnés"
        },
        {
            icon: "building",
            number: 825,
            label: "Solutions sur-mesure livrées"
        },
        {
            icon: "users",
            number: 89,
            label: "Taux de satisfaction client",
            isPercentage: true
        },

        {
            icon: "briefcase",
            number: 10,
            label: "Avocats partenaires"
        },


    ];


    return (
        <div>
            <MiniHero text={"Qui sommes-nous ?"} url={"/assets/img/theme/mini0.jpg"}/>
            <Intro/>
            <EngagementsSection/>
            <StatisticsCounter stats={stats}/>
            <LawFirmHero/>
            <RecentBlogArea items={blogs.slice(-3)}/>
        </div>
    );
};

export default About;
